<template>
  <div class="serviceList">
    <div class="itemList">
      <el-select v-model="leftValue" style="margin-left:10px;" aria-placeholder="请选择"  @change="selectChannel">
        <el-option
          v-for="(item) in allChannel"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          :disabled="item.value === rightValue"
        />
      </el-select>
    </div>
    <div class="itemList" v-if="type !== 'timeOrgTerm' || (type === 'timeOrgTerm' && selectChannels.length > 1)">
      <el-select v-model="rightValue" style="margin-left:10px;" placeholder="全部" @change="selectChannel">
        <el-option
          v-for="(item) in allChannel"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          :disabled="item.value === leftValue"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
/**
 * @param channel：被选中服务商
 * @param choose-channel: function，选择服务商传递函数
 * 调用示例: <serviceList :channel='xx' @choose-channel='xx'></serviceList>
 */
import { initOptions } from '@/utils/constant'

export default {
  name: 'serviceList',
  props: {
    backColor: String,
    type: String,
    selectChannels: Array,
    chartParam: Object
  },
  data() {
    return {
      rightValue: this.chartParam.rightValue,
      leftValue: this.chartParam.leftValue,
      allChannel: this.type === 'timeOrgTerm' ? initOptions : [
        { name: '公益课账号领取人数', value: 'sum_b2c_num' },
        { name: '公益课首课完课人数', value: 'b2c_sum_0fin_num' },
        { name: '公益课全部课完课人数', value: 'b2c_sum_finish_num' },
        { name: '体验课支付人数', value: 'sum_l1_num' },
        { name: '体验课首课完课人数', value: 'l1_sum_0fin_num' },
        { name: '体验课全部课完课人数', value: 'l1_sum_finish_num' },
        { name: '精品课（年课）人数', value: 'sum_annual_renewal_num' },
        { name: '精品课（季课）人数', value: 'sum_quarter_renewal_num' },
      ]
    }
  },
  methods: {
    findName(e) {
      if (this.type && this.type === 'timeOrgTerm') {
        return initOptions.filter(item => item.value === e)
      } else {
        return this.allChannel.filter(item => item.value === e)
      }
    },
    selectChannel() {
      const obj = {
        leftValue: this.leftValue,
        rightValue: this.rightValue
      }
      const leftName = this.findName(this.leftValue);
      const rightName = this.findName(this.rightValue);
      const objName = {
        leftName: leftName && leftName.length > 0 ? leftName[0].name : '',
        rightName: rightName && rightName.length > 0 ? rightName[0].name : ''
      }
      this.$emit('choose-channel', obj);
      this.$emit('choose-name', [objName.leftName, objName.rightName]);
    }
  },
  watch: {
    selectChannels: {
      handler(newVal) {
        if (newVal && newVal.length && this.type === 'timeOrgTerm') {
          this.leftValue = newVal[0].value || 'user_cnt'
          this.rightValue = newVal.length > 1 ? newVal[1].value : null
          this.allChannel = newVal
        }
      }
    },
    deep: true
  }
};
</script>

<style lang="less" scoped>
  .serviceList {
    .itemList{
      display: inline-block;
      margin-right: 10px;
    }
  }
</style>
